import {
  listEventTimeSlots as publicListEventTimeSlots,
  getEventTimeSlot as publicGetEventTimeSlot,
} from './bookings-availability-v2-time-slot-event-time-slots.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const listEventTimeSlots: MaybeContext<
  BuildRESTFunction<typeof publicListEventTimeSlots> &
    typeof publicListEventTimeSlots
> = /*#__PURE__*/ createRESTModule(publicListEventTimeSlots);
export const getEventTimeSlot: MaybeContext<
  BuildRESTFunction<typeof publicGetEventTimeSlot> &
    typeof publicGetEventTimeSlot
> = /*#__PURE__*/ createRESTModule(publicGetEventTimeSlot);

export { LocationType } from './bookings-availability-v2-time-slot-event-time-slots.universal.js';
export {
  TimeSlot,
  Location,
  EventInfo,
  WaitingList,
  BookingPolicyViolations,
  AvailableResources,
  Resource,
  NestedTimeSlot,
  NonBookableReasons,
  ListEventTimeSlotsRequest,
  CursorPaging,
  ListEventTimeSlotsResponse,
  CursorPagingMetadata,
  Cursors,
  GetEventTimeSlotRequest,
  GetEventTimeSlotResponse,
  ListAvailabilityTimeSlotsRequest,
  CustomerChoices,
  ResourceType,
  ListAvailabilityTimeSlotsResponse,
  GetAvailabilityTimeSlotRequest,
  GetAvailabilityTimeSlotRequestCustomerChoices,
  GetAvailabilityTimeSlotResponse,
  ListMultiServiceAvailabilityTimeSlotsRequest,
  Service,
  V2CustomerChoices,
  ListMultiServiceAvailabilityTimeSlotsResponse,
  GetMultiServiceAvailabilityTimeSlotRequest,
  GetMultiServiceAvailabilityTimeSlotResponse,
  ListEventTimeSlotsOptions,
  GetEventTimeSlotOptions,
} from './bookings-availability-v2-time-slot-event-time-slots.universal.js';
export { LocationTypeWithLiterals } from './bookings-availability-v2-time-slot-event-time-slots.universal.js';
